export const getInitials = (name = "") => {
  const parts = name.split(" ").filter(Boolean);
  if (!parts.length) return "P";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
};

export const normalizeSourceType = (source = "") => {
  const val = String(source || "").toLowerCase();
  return val.includes("ai") ? "AI" : "PAYER";
};

export const parsePayersFromSource = (source = "") => {
  if (!source || normalizeSourceType(source) === "AI") return [];
  return source
    .split(",")
    .map((p) => p.trim())
    .filter(Boolean);
};

export const getSourceValueForApi = (sourceType, payers) => {
  if (sourceType === "AI") return "AI & Scribe";
  return payers.join(", ");
};

export const mapCareGapItem = (item) => {
  const sourceType = normalizeSourceType(item.source);
  const payers = parsePayersFromSource(item.source);

  return {
    ...item,
    type: sourceType,
    payers,
    text: item.care_gap_name,
    reason: item.care_gap_detials,
    notes: item.notes || "",
  };
};
